import { Outlet, useParams } from 'react-router-dom';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { WorkItemHeader } from './notes';
import { IWorkItemContext, WorkItemProvider, useWorkItemOptions, useWorkItemOverview, useWorkItemTemplate } from 'hooks/work-items';
import WorkItemTabs from './WorkItemTabs';
import { useMemo, useRef } from 'react';
import { IWorkItemOverview, IWorkItemTemplate } from 'models/work-items';

const WorkItemNotFound = () => (
    <Typography variant='subtitle1' color='error'>Work Item not found.</Typography>
);

type WorkItemLayoutProps = {
    hideTabs?: boolean;
};

const WorkItemLayout: React.FC<WorkItemLayoutProps> = (props) => {
    const { hideTabs } = props;

    const { workItemId } =  useParams();   
    const [ workItem, loading, updater, error ] = useWorkItemOverview(Number(workItemId));
    const [ options, optsLoading, getOptionsForStatus ] = useWorkItemOptions(Number(workItemId));
    const [ template, templateLoading ] = useWorkItemTemplate({
        workItemId: Number(workItemId)
    });
    
    const btnContainer = useRef<HTMLElement>(null);

    const value = useMemo<IWorkItemContext>(() => ({
        workItem,
        template,
        options,
        getOptionsForStatus,
        btnContainer: () => btnContainer.current,
        updateWorkItemOverview: (overview?: IWorkItemOverview) => {
            updater(overview, false);
        }
    }), [ workItem, template, options ]);

    return (
        <Box>
            {loading ? <CircularProgress /> :
                workItem ?
                    <WorkItemProvider value={value}>
                        <WorkItemHeader workItem={workItem} />
                        { hideTabs ? null : <WorkItemTabs btnContainer={btnContainer} /> }
                        <Box sx={{
                            display: 'flex'
                        }}>
                            <Grid container sx={{ minWidth: '100%' }}>
                                <Grid item xs={12}>
                                    <Outlet />
                                </Grid>
                            </Grid>
                        </Box>
                    </WorkItemProvider>
                    : <WorkItemNotFound />
            }
        </Box>
    );
};
export default WorkItemLayout;